import React from "react";
import { getSdk } from "../../services/sdkService";
import { Loading, Modal, Button, withFocusable } from "../../services/visualLibraryService";
import { HeadingStyled, ContainerStyled } from "../../styles/shared-styles";
import {
  FullCatalogPageStyled,
  LayoutStyled,
  ArrowScrollStyled,
  BlockStyled,
  BlockStyledTabs,
  GridStyled,
  SecondaryMenuStyled,
  TextNoFound
} from "./styles/Styled";
import { i18n, directions } from "../../services/i18nService";
import getBrands from "../../services/layoutService";
import { getSpSportsPackageDisplayName, getStarzplayPackageDisplayName } from '../../services/sportPackageService'
import { withAppState, getAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { resolution } from "../../config/ui/resolutionConfig";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { config } from "../../config/config";
import { defaultFocusPath as headerFocusPath } from "../../components/Header";
import { routes } from "../../routes";
import packageJson from "../../../package.json";

const appVersionQueryParameter = `?version=${packageJson?.version}`;
const defaultFocusPath = GridStyled.defaultFocusPath;
const LAST_ADDED = "lastAdded";
const PAGE = "fullCatalog";
const GRID_ROWS = 3;
const ButtonModalFocus = withFocusable(Button);
let sdk = null;

class Brands extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      catalogItems: null,
      brandsTabs: [],
      isExiting: false,
      isGettingItems: false,
      isTabSelected: false,
    };
    this.onPosterAction = this.onPosterAction.bind(this);
    this.onTabSelected = this.onTabSelected.bind(this);
    this.switchMainMenuToGrid = this.switchMainMenuToGrid.bind(this);
    this.focusMenu = this.focusMenu.bind(this);
    this.makeFocusDefault = this.makeFocusDefault.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.scrollUpDown = this.scrollUpDown.bind(this);
    this.onBack = this.onBack.bind(this);
    this.setDefaultFocusValues = this.setDefaultFocusValues.bind(this);
    this.isNavbarDisappear = this.isNavbarDisappear.bind(this);
    this.selectedGenre = null;
    this.sectionName = this.props.route.split("/").pop();
    this.menu = null;
    this.fromScroll = true;
    this.secondaryMenuSelectedIndex =
      (this.props.history.location.state && this.props.history.location?.state?.secondaryMenuSelectedIndex) || 0;
  }

  closeConfirmModal() {
    const { location } = this.props;
    this.setState({ isExiting: false });
    if (location?.state?.scrollToGrid === -1) {
      this.props.setFocus(headerFocusPath);
    } else {
      this.props.setFocus(GridStyled.defaultFocusPath);
    }
  }

  /**
   * Redirects to a certain title detail page when the user presses on a title poster.
   */
  onPosterAction() {
    const { history } = this.props;
    const focusedItem = history.location?.state?.focusedItem;
    const title = this.state.catalogItems[focusedItem || 0];
    const totalItemShow = this.props.applicationState?.userLogged ?  resolution.grid?.brands?.columnCount : resolution.grid?.columnCountInLogout?.columnCount;
    const scrollToRow = Math.floor(focusedItem / totalItemShow);
    const sectionName = (history.location.state && history.location?.state?.sectionName) || this.sectionName;
    this.props.history.push({
      state: {
        ...history.location.state,
        secondaryMenuSelectedIndex : this.secondaryMenuSelectedIndex,
        scrollToGrid:0,
        scrollToRow
      }
    });
    const brandPage = `${routes.brands}/${title.name}`;
    history.push({ pathname: brandPage, state: { sectionName: sectionName } });
  }

  onTabSelected(index) {
    const { history, location } = this.props;
    this.secondaryMenuSelectedIndex = index;
    history.replace({
      state: {
        ...location.state,
        secondaryMenuSelectedIndex: index,
        focusedItem: 0,
        scrollToGrid:0,
        scrollToRow: 0
      }
    });
    this.setState({ isTabSelected: true });
    this.getCatalogueItems(this.secondaryMenuSelectedIndex);
    this.props.setFocus(GridStyled.defaultFocusPath);
  }

  switchMainMenuToGrid(event) {
    event.preventDefault();
    event.keyCode === 38 && this.onModulesUp();
    event.keyCode === 40 && this.onModulesDown();
    event.keyCode === 37 && this.onModulesLeft();
    event.keyCode === 39 && this.onModulesRight();
  }

  onBack() {
    const globalModal = getAppState().globalModal;
    const { history } = this.props;
    if (this.state.isExiting) {
      // Close exit popup
      this.closeConfirmModal();
      this.props.setFocus(headerFocusPath);
    } else if (this.props.applicationState.currentFocus === "mainMenu") {
      if ((!globalModal || globalModal.dismissable) && config.get().featureToggles.exitAppPopup) {
        this.setState({ isExiting: true });
      }
    } else {
      history.replace({
        state: {
          scrollToGrid: -1
        }
      });
      this.processGridFeeds(this.state.catalogItems);
      this.props.setFocus(headerFocusPath);
    }
    return true;
  }

  
  onModulesLeft() {
    const { history, location } = this.props;
    this.processGridFeeds(this.state.catalogItems);
    if (
      i18n.getDirection() === directions.RIGHT_TO_LEFT &&
      this.props.applicationState.currentFocus.includes("secondaryItem_")
    ) {
      setTimeout(() => {
        this.processGridSelectedFeeds(this.state.catalogItems[0]);
        this.props.setFocus(GridStyled.defaultFocusPath);
      }, 10);
      history.replace({
        state: {
          scrollToGrid: 0,
          focusedItem: 0,
          scrollToRow: 0
        }
      });
    }
  }

  onModulesRight() {
    const { history, location } = this.props;
    this.processGridFeeds(this.state.catalogItems);
    if (
      i18n.getDirection() === directions.LEFT_TO_RIGHT &&
      this.props.applicationState.currentFocus.includes("secondaryItem_")
    ) {
      setTimeout(() => {
        this.processGridSelectedFeeds(this.state.catalogItems[0]);
        this.props.setFocus(GridStyled.defaultFocusPath);
      }, 10);
      history.replace({
        state: {
          scrollToGrid: 0,
          focusedItem: 0,
          scrollToRow: 0
        }
      });
    }
  }

  onModulesUp() {
    if (getAppState().globalModal || this.state.isExiting === true) return;
    const { history, location } = this.props;
    const liElement = document.querySelector("li.focused");
    const tab = liElement ? liElement.innerHTML : "";
    if (
      (!tab && location?.state?.scrollToRow === 0) ||
      tab === i18n.get("pages.brands.actives") ||
      (tab === i18n.get("pages.brands.inactives") && this.state.brandsTabs.length === 1) || 
      (!tab && !this.state.brandsTabs)
    ) {
      this.props.setFocus(headerFocusPath);
      this.processGridFeeds(this.state.catalogItems);
      this.fromScroll = true;
      history.replace({
        state: {
          scrollToGrid: -1,
          focusedItem: location?.state?.focusedItem,
          scrollToRow: undefined
        }
      });
    } else if (tab && tab === i18n.get("pages.brands.inactives")) {
      this.props.setFocus("secondaryItem_0");
    }
  }

  onModulesDown(isScroll) {
    if (getAppState().globalModal || this.state.isExiting === true || this.state.catalogItems.length === 0) return;
    // if (getAppState().globalModal || this.state.isExiting === true) return;
    const { history, location } = this.props;
    if(this.props.applicationState.userLogged === true){
      if (location?.state?.scrollToGrid === -1 || location?.state?.scrollToGrid === undefined) {
        this.props.setFocus(GridStyled.defaultFocusPath);
        history.replace({
          state: {
            scrollToGrid: 0,
            focusedItem: location?.state?.focusedItem ? location?.state?.focusedItem - 3 : -3,
            scrollToRow: 0
          }
        });
      }
    }
    if(this.props.applicationState.userLogged === false){
      if (location?.state?.scrollToGrid === -1 || location?.state?.scrollToGrid === undefined) {
        this.props.setFocus(GridStyled.defaultFocusPath);
        history.replace({
          state: {
            scrollToGrid: 0,
            focusedItem: location?.state?.focusedItem ? location?.state?.focusedItem - 4 : -4,
            scrollToRow: 0
          }
        });
      }
    }
  }

  processGridFeeds(feeds) {
    const tab = this.state.brandsTabs[this.menu.state.selectedIndex];
    return feeds.map((feed, index) => {
      const versionedImageUrl = `${feed?.configuration?.logoDefaultPNG}${appVersionQueryParameter}`
      // FIXME Shouldn't this be done in SDK or Middleware?
      if (tab === i18n.get("pages.brands.inactives") || !tab) {
        feed["icon"] = "lock";
        feed["imageUrl"] = versionedImageUrl
          ? versionedImageUrl
          : versionedImageUrl;
        feed["posterUrl"] = feed?.configuration?.backgroundImagePNG
          ? feed?.configuration?.backgroundImagePNG
          : feed?.configuration?.backgroundImageJPG;
        feed["title"] = feed.name;
        feed.itemIndex = index;
        feed["infoText"] = !feed?.configuration?.isStandalone ? (feed?.configuration?.isSports && feed?.configuration?.isIncludedInSportsPackage) ? i18n.get("pages.brands.partOf", getSpSportsPackageDisplayName()) : feed?.isBrand ?  i18n.get("pages.brands.partOf", getStarzplayPackageDisplayName()) : null : null;
      } else {
        feed["icon"] = null;
        feed["infoText"] = null;
        feed["imageUrl"] = versionedImageUrl
          ? versionedImageUrl
          : versionedImageUrl;
        feed["posterUrl"] = feed?.configuration?.backgroundImagePNG
        ? feed?.configuration?.backgroundImagePNG
        : feed?.configuration?.backgroundImageJPG;
        feed.itemIndex = index;
        feed["title"] = feed.name;
      }
      return feed;
    });
  }

  async setMenuItems() {
    if(!getAppState().userLogged){
      this.setState({ brandsTabs: [] })
    }else if (this.activeChannels.length < 1) {
      this.setState({ brandsTabs: [i18n.get("pages.brands.inactives")] });
    } else if (this.inActiveChannels.length < 1) {
      this.setState({ brandsTabs: [i18n.get("pages.brands.actives")] });
    } else {
      let brandsTabs = [i18n.get("pages.brands.actives"), i18n.get("pages.brands.inactives")];
      this.setState({ brandsTabs });
    }
  }

  /**
   * Retrieves catalogue items by section name value and calls grid render update method to show new titles.
   * @param {Object} params - Object containing pagination and sorting related data.
   * @param {String|Boolean} isSpecialSubsection - String in case it is an special subsection and false if not.
   */
  async getCatalogueItems(index) {
    (this.state.brandsTabs.length > 1 && index == 0) || this.inActiveChannels.length < 1
      ? await this.update(this.activeChannels,"active")
      : await this.update(this.inActiveChannels,"inactive");
  }

  /**
   * Sets and makes page re-render a new bunch of titles retrieved from a genre/category selection change.
   * @param {Array} items - Array of new genre/category titles.
   */
  async update(items,status) {
    const { location } = this.props;
    //const tab = this.state.brandsTabs[this.menu.state.selectedIndex];
    this.setState({ catalogItems: null });
    const catalogItems = this.processGridFeeds(items);
    let totalCatalogItems = catalogItems.length;
    if (location.referrer === undefined) location.referrer = "brands";
      status === 'active' &&
      location.referrer &&
      location.referrer.includes("brands") &&
      this.processGridSelectedFeeds(
        location?.state?.focusedItem === undefined ? catalogItems[0] : catalogItems[location?.state?.focusedItem]
      );

    this.setState({
      catalogItems: catalogItems,
      isGettingItems: false,
      totalCatalogItems : totalCatalogItems
    });

    if (this.isNavbarDisappear()) {
      this.setDefaultFocusValues();
    }
  }

  isNavbarDisappear() {
    // If scrollToGrid is undefined, or values are mis match due to page reload, then need to set the default values
    const { location, applicationState } = this.props;
    let isSetDefaultValues = false;
    if ((location?.state?.scrollToGrid === undefined && location?.state?.focusedItem === undefined) || (location?.state?.scrollToGrid === -1 && applicationState?.currentFocus === 'grid')) {
      isSetDefaultValues = true;
    }
    return isSetDefaultValues;
  }

  setDefaultFocusValues() {
    const { history, setFocus } = this.props;
    setFocus("mainMenu");
    history.replace({
      state: {
        scrollToGrid: -1,
        focusedItem: 0,
        scrollToRow: undefined
      }
    });
  }

  focusMenu() {
    if(this.state.brandsTabs.length > 0){
      this.menu && this.props.setFocus(this.menu.getSelectedItem());
      this.makeFocusDefault();
    } else {
      const { history, location } = this.props;
         const totalItemShow = this.props.applicationState.userLogged ?  resolution.grid.brands.columnCount : resolution.grid.columnCountInLogout.columnCount;
         history.replace({
            state: {
              scrollToGrid: 0,
              focusedItem: location?.state.focusedItem,
              scrollToRow: Math.floor(location?.state?.focusedItem / totalItemShow)
           }
         });
    }
  }

  makeFocusDefault() {
    const { history } = this.props;
    history.replace({
      state: {
        scrollToGrid: 0,
        focusedItem: 0,
        //scrollToRow: 0
      }
    });
  }

  processGridSelectedFeeds(feeds) {
    const versionedImageUrl = `${feeds?.configuration?.logoDefaultPNG}${appVersionQueryParameter}`
    feeds["posterUrl"] = feeds?.configuration?.backgroundImagePNG
      ? feeds?.configuration?.backgroundImagePNG
      : feeds?.configuration?.backgroundImageJPG;
    feeds["imageUrl"] = versionedImageUrl
      ? versionedImageUrl
      : versionedImageUrl;
    //feeds.itemIndex = this.props.location?.state?.focusedItem;
    feeds["title"] = feeds.name;
    return feeds;
  }

  onChange({ focusedItem }) {
    if (getAppState().globalModal || this.state.isExiting === true) return;
    const { location, history } = this.props;
    const tab = this.state.brandsTabs && this.state.brandsTabs[this.menu && this.menu.state.selectedIndex];
    const totalItemShow = this.props.applicationState?.userLogged ?  resolution.grid?.brands?.columnCount : resolution.grid?.columnCountInLogout?.columnCount;
    if (focusedItem !== location?.state?.focusedItem) {
      (tab === i18n.get("pages.brands.inactives") || !tab) &&
        this.processGridFeeds(this.state.catalogItems) &&
        this.processGridSelectedFeeds(this.state.catalogItems[focusedItem]);
      history.replace({
        state: {
          ...location.state,
          focusedItem,
          scrollToRow: Math.floor(focusedItem / totalItemShow)
        }
      });
    }
    if (focusedItem !== location?.state?.focusedItem) {
      tab === i18n.get("pages.brands.actives") &&
      this.processGridFeeds(this.state.catalogItems) &&
      this.processGridSelectedFeeds(this.state.catalogItems[focusedItem]);
      history.replace({
        state: {
          ...location.state,
          focusedItem,
          scrollToRow: Math.floor(focusedItem / totalItemShow)
        }
      });
    }
  }

  scrollUpDown(event) {
    const {location,history} = this.props;
    this.processGridFeeds(this.state.catalogItems)
    if (event.deltaY > 0) {
      // down wheel move
      this.onModulesDown(true);
    } else if (event.deltaY < 0) {
      // up wheel moves
      if( this.fromScroll === true && location?.state?.scrollToRow === 0 ){
        this.fromScroll = false;
        return;
      }
      this.fromScroll === false && this.onModulesUp();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.switchMainMenuToGrid, false);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isExiting } = this.state;
    isExiting && !prevState.isExiting && this.confirmModalFocusPath && this.confirmModalFocusPath.props.setFocus();
  }

  componentWillUpdate() {
    this.state.isTabSelected && this.getCatalogueItems(this.secondaryMenuSelectedIndex);
    this.setState({ isTabSelected: false });
  }

  async componentDidMount() {
    const { onRef,history,location } = this.props;
    document.addEventListener("keydown", this.switchMainMenuToGrid, false);
    const subscription = (this.props.applicationState.subscriptions || []).find(s => s.name === this.sectionName) || {};
    this.setState({ displayName: subscription.displayName });
    trackPage.call(this, PAGE);
    onRef && onRef(this);
    await this.fetchData();
    
    if(!location.referrer.includes('brands')){
    setTimeout(() => {
      this.onModulesDown();
      this.processGridFeeds(this.state.catalogItems)
      this.processGridSelectedFeeds(this.state.catalogItems[0]);
      history.replace({
        state: {  
          focusedItem: 0,
          scrollToGrid:0,
          scrollToRow:0
        }
      });
    }, 100);
   }
  }

  async fetchData() {
    sdk = await getSdk();
    this.activeChannels = getBrands("ACTIVE");
    this.inActiveChannels = getBrands("IN_ACTIVE");
    await this.setMenuItems();
    await this.getCatalogueItems(this.secondaryMenuSelectedIndex);
  }

  render() {
    const { location,history } = this.props;
    const { catalogItems, brandsTabs, isGettingItems } = this.state;
    const totalItemShow = this.props.applicationState?.userLogged ?  resolution.grid?.brands?.columnCount : resolution.grid?.columnCountInLogout?.columnCount;
    return (
      <>
        {this.state.isExiting && ( // FIXME: make this work with globalModal logic when possible (and the other places where is appears too.
          <Modal headingText={i18n.get("global.modals.exit.title")} mainText={i18n.get("global.modals.exit.text")}>
            <ButtonModalFocus
              label={i18n.get("global.no")}
              focusPath="noOkModal_passThru"
              onEnterPress={this.closeConfirmModal}
              onMouseUp={this.closeConfirmModal}
              size="small"
              spacing="small"
              onRef={ref => (this.confirmModalFocusPath = ref)}
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("", "@okModal_passThru")}
              dataSnRight={i18n.directionFlip("@okModal_passThru", "")}
            />
            <ButtonModalFocus
              label={i18n.get("global.yes")}
              focusPath="okModal_passThru"
              onEnterPress={getSdk().systemManager.application.exit}
              onMouseUp={getSdk().systemManager.application.exit}
              size="small"
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("@noOkModal_passThru", "")}
              dataSnRight={i18n.directionFlip("", "@noOkModal_passThru")}
            />
          </Modal>
        )}

        <LayoutStyled
          isVisible={location?.state?.scrollToGrid === -1}
          position={
            location?.state?.scrollToGrid > -1
              ? resolution.layout.positionHeaderHidden
              : resolution.layout.positionHeaderVisible
          }
        >
          <ArrowScrollStyled
            label={
              this.props.applicationState.userLogged
                ? i18n.get("pages.layout.searchAndMenu")
                : i18n.get("pages.layout.loginAndMenu")
            }
            icon="arrowUp"
            onClick={() => this.onModulesUp(true)}
            isVisible={location?.state?.scrollToGrid === 0}
          />
          { this.state.totalCatalogItems !== 0 ? (
          <FullCatalogPageStyled>
            <HeadingStyled rank={2} text={"&nbsp&nbsp"} />
            <ContainerStyled>
              {brandsTabs && (
                <BlockStyledTabs isTabExits={brandsTabs.length > 0 ? true : false }>
                  <SecondaryMenuStyled
                    items={brandsTabs.length > 0 ? brandsTabs : null}
                    onClick={this.onTabSelected}
                    hover={false}
                    onRef={menu => (this.menu = menu)}
                    secondaryMenuSelectedIndex={this.secondaryMenuSelectedIndex}
                    dataSnDown=""
                    dataSnUp={headerFocusPath}
                    dataSnLeft={i18n.getDirection() === directions.LEFT_TO_RIGHT ? undefined : defaultFocusPath}
                    dataSnRight={i18n.getDirection() === directions.LEFT_TO_RIGHT ? defaultFocusPath : undefined}
                  />
                </BlockStyledTabs>
              )}
              <BlockStyled
                isTabExits={brandsTabs.length > 0 ? true : false }
                onWheel={e => {
                  this.scrollUpDown(e);
                }}
                onClick={() => this.onModulesDown(true)}
              >
                {catalogItems ? (
                  <GridStyled
                    focusPath={defaultFocusPath}
                    titles={this.state.catalogItems}
                    noResultText={i18n.get("pages.brands.noResults")}
                    onEnterPress={this.onPosterAction}
                    columnCount={brandsTabs.length > 0 ? resolution.grid?.brands?.columnCount : resolution.grid?.columnCountInLogout?.columnCount}
                    columnWidth={resolution.grid.brands.columnWidth}
                    itemHeight={resolution.grid.brands.itemHeight}
                    rowHeight={resolution.grid.brands.rowHeight}
                    gridDataContent={this.selectedGenre}
                    offsetFixed={true}
                    disableCrop={true}
                    navigateLeft={i18n.getDirection() === directions.LEFT_TO_RIGHT && this.focusMenu}
                    navigateRight={i18n.getDirection() === directions.RIGHT_TO_LEFT && this.focusMenu}
                    direction={i18n.getDirection()}
                    onChange={this.onChange}
                    scrollToRow={location.state && location?.state?.scrollToRow}
                    focusedItem={location.state && location?.state?.focusedItem}
                    inactive={isGettingItems}
                    isFocused={this.props.applicationState.currentFocus === GridStyled.defaultFocusPath}
                    isBrandsPage={true}
                    isTabExits={brandsTabs.length > 0 ? true : false}
                  >
                    {isGettingItems && <Loading overlay opacity="0" />}
                  </GridStyled>
                ) : (
                  <Loading overlay />
                )}
              </BlockStyled>
            </ContainerStyled>
          </FullCatalogPageStyled>
         ) : 
           <TextNoFound>
              {i18n.get("pages.brands.noResults")}
           </TextNoFound>
         }
        </LayoutStyled>
      </>
    );
  }
}

const Component = withAppState(withSubtheme(Brands));

Component.defaultFocusPath = GridStyled.defaultFocusPath;

export default Component;
